import { RangeCalender } from '@src/components/ui/RangeCalender';
import { PresetsDatePicker } from '@src/components/ui/RangeCalender/types';
import { SingleCalender } from '@src/components/ui/SingleCalender';
import { useTheme } from '@src/components/ui/ThemeProvider';
import { isFormValidationError } from '@src/utilities/form';
import { FormItemProps } from 'antd/es/form';
import dayjs, { Dayjs } from 'dayjs';
import { ICommonFormProps } from '../DynamicForm.types';

export function FormDatePicker(props: ICommonFormProps) {
    const { theme } = useTheme();
    const formItemProps: FormItemProps = {
        label: (
            <span>
                {props.label}
                {props.registerOptions?.required && (
                    <span
                        className=" ml-1"
                        style={{ color: theme.colors.error.main.filled }}
                    >
                        *
                    </span>
                )}
            </span>
        ),
        validateStatus: props.errors ? 'error' : undefined,
        help: props.errors
            ? isFormValidationError(props.errors.type)
                ? props.errors?.message
                : `${props.label} ${props.errors.type}`
            : undefined,
        labelCol: { span: 24 },
        wrapperCol: { span: 24 },
        colon: false,
        ...props.formProps,
    };

    if (props.formProps?.useRange) {
        const rangeProps = {
            formItemProps,
            value: props.field?.value
                ? [dayjs(props.field.value[0]), dayjs(props.field.value[1])]
                : undefined,
            onChange: (value: [Dayjs, Dayjs] | [Date, Date]) => {
                if (props.setValue) {
                    props.setValue(props.keyName, value);
                }
            },
            format: props.formProps?.format || 'YYYY-MM-DD',
            placement: props.formProps?.placement || 'bottomLeft',
            allowClear: props.formProps?.allowClear ?? true,
            showToday: props.formProps?.showToday ?? false,
            status: props.errors ? 'error' : undefined,
            size: props.formProps?.size || 'middle',
            disabled: props.disabled || false,
            presets: props.formProps?.presets || PresetsDatePicker,
            label: props.label,
            singleMonthView: props.formProps?.singleMonthView,
            renderFooter: props.formProps?.renderFooter,
            isWithoutFooter: props.formProps?.isWithoutFooter,
            defaultValue: props.formProps?.defaultValue,
            open: props.formProps?.open,
            onOpenChange: props.formProps?.onOpenChange,
        };
        return <RangeCalender {...(rangeProps as any)} />;
    }

    const singleProps = {
        formItemProps,
        value: props.field?.value ? dayjs(props.field.value) : undefined,
        onChange: (value: Dayjs | Date | null) => {
            if (props.setValue) {
                props.setValue(props.keyName, value);
            }
        },
        format: props.formProps?.format || 'YYYY-MM-DD',
        placement: props.formProps?.placement || 'bottomLeft',
        allowClear: props.formProps?.allowClear ?? true,
        showToday: props.formProps?.showToday ?? false,
        status: props.errors ? 'error' : undefined,
        size: props.formProps?.size || 'middle',
        disabled: props.disabled || false,
    };
    return <SingleCalender {...(singleProps as any)} />;
}
